import { graphql } from 'gatsby';
import * as React from 'react';
import { Headline } from '@lce/slice-ui';

import LeavingSiteDialog from '../components/LeavingSiteDialog';
import IPageProps from '../definitions/IPageProps';
import IGiftCardsPageContent from '../definitions/IGiftCardsPageContent';

import MascotBanner from '../components/MascotBanner';
import * as Styled from '../page-styles/GiftCards.style';
import Layout from '../components/PageLayout/PageLayout';

export interface IGiftCardsPageState {
  leavingSite: boolean;
  requestUrl: string;
}

class GiftCardsPage extends React.Component<IPageProps<IGiftCardsPageContent>, IGiftCardsPageState> {
  constructor(props: IPageProps<IGiftCardsPageContent>) {
    super(props);
    this.state = { leavingSite: false, requestUrl: '' };
  }

  render() {
    const {
      data: {
        datoCmsGiftCardsPage: page,
        datoCmsLeavingSiteDialog,
      },
    } = this.props;

    const BannerMessage = (
      <Styled.BannerMessage>
        <Headline variant="primary">{ page.headline }</Headline>
        <Styled.BannerParagraph>{ page.body }</Styled.BannerParagraph>
        <Styled.BannerParagraph>{ page.leavingSiteDisclaimer }</Styled.BannerParagraph>
        <Styled.InlineSafeLink
          href="http://www.givex.com/Merchant_pages/3825/terminal/terminalframes.htm"
          leavingSiteRequest={ this.leavingSiteRequest }
        >
          <Styled.CtaButton variant="solid">{ page.buttonTitle }</Styled.CtaButton>
        </Styled.InlineSafeLink>
      </Styled.BannerMessage>
    );

    return (
      <>
        <LeavingSiteDialog
          isDialogVisible={ this.state.leavingSite }
          requestUrl={ this.state.requestUrl }
          leavingSiteCancel={ this.leavingSiteCancel }
          content={ datoCmsLeavingSiteDialog }
        />
        <MascotBanner mascot={ Styled.Mascot } message={ BannerMessage } size="lg" />
      </>
    );
  }

  private leavingSiteRequest = (href: string) => {
    this.setState({ leavingSite: true, requestUrl: href });
  }

  private leavingSiteCancel = () => {
    this.setState({ leavingSite: false, requestUrl: '' });
  }
}

export default Layout(GiftCardsPage);

export const pageQuery = graphql`
  query GiftCardsPage($shortLocale: String!) {
    datoCmsGiftCardsPage(locale: { eq: $shortLocale }){
      headline
      body
      buttonTitle
      leavingSiteDisclaimer
    }
    datoCmsFooter(locale: { eq: $shortLocale }){
      ...FooterFragment
    }
    datoCmsFranchisingCard(locale: { eq: $shortLocale }) {
      ...FranchisingCardFragment
    }
    datoCmsFreeCbCard(locale: { eq: $shortLocale }) {
      ...FreeCBCardFragment
    }
    datoCmsLeavingSiteDialog(locale: { eq: $shortLocale }){
      ...LeavingSiteDialogFragment
    }
  }
`;
